export const collectionOptions: any = [
	{
		title: 'happy',
		description: 'brightColors',
		colors: [
			{
				color: '#E1B71A',
				image: '3070_M'
			},
			{
				color: '#9B4D97',
				image: '4002_L+M',
			},
			{
				color: '#F37021',
				image: '3014_M',
			},
			{
				color: '#40235C',
				image: '3017_M',
			},
			{
				color: '#0087AF',
				image: '3018_M',
			},
			{
				color: '#F3BAC9',
				image: '3021_M',
			},
			{
				color: '#039F92',
				image: '4024_L+M',
			}
		]
	},
	{
		title: 'neon',
		description: 'neonColors',
		colors: [
			{
				color: '#83BD47',
				image: '3027_M'
			},
			{
				color: '#EA5225',
				image: '3030_M'
			},
			{
				color: '#F49B34',
				image: '3014_M'
			},
			{
				//color: '#E50E77',
				color: 'rgba(229,14,119,0.6)',
				image: '3021_M'
			},
			{
				color: '#E94242',
				image: '3014_M'
			},
			{
				color: '#DFE47E',
				image: '3083_M_2'
			},
			{
				color: 'linear-gradient(90deg, #85BD41 0%, #E4E46D 49.5%, #ED8247 100%)',
				image: '4001_L+M'
			}
		]
	},
	{
		title: 'classic',
		description: 'earthTones',
		colors: [
			{
				color: '#B2947A',
				image: '3007_M'
			},
			{
				color: '#625E3F',
				image: '4007_L+M'
			},
			{
				color: '#151515',
				image: '4021_L+M'
			},
			{
				color: '#59241A',
				image: '3006_M'
			},
			{
				color: '#884713',
				image: '4022_L+M'
			},
			{
				color: '#3E4219',
				image: '3009_M'
			}
		]
	},
	{
		title: 'cottonCandy',
		description: 'sweetColors',
		colors: [
			{
				color: '#7EB866',
				image: '3024_M'
			},
			{
				color: '#43ACC4',
				image: '4013_L+M'
			},
			{
				color: '#A0BBCF',
				image: '3025_M'
			},
			{
				color: '#F4AD99',
				image: '3022_M'
			},
			{
				color: '#DD839D',
				image: '3021_M'
			},
			{
				color: '#EDDF99',
				image: '3078_M'
			}
		]
	}
];

export const colorsOptions: any = [
	{
		title: 'Brownie (L)',
		secondTitle: 'Sand (M)',
		description: '3 ensfargede',
		image: '4000_L+M',
	},
	{
		title: 'Neony (L)',
		secondTitle: 'Neon Yellow (M)',
		description: '3 ensfargede',
		image: '4001_L+M',
	},
	{
		title: 'Syrina (L)',
		secondTitle: 'Lilac Blue (M)',
		description: '3 ensfargede',
		image: '4002_L+M',
	},
	{
		title: 'Pinky (L)',
		secondTitle: 'Peachie Pink (M)',
		description: '3 ensfargede',
		image: '4003_L+M',
	},
	{
		title: 'Blueba (L)',
		secondTitle: 'Cobalt Blue (M)',
		description: '3 ensfargede',
		image: '4004_L+M',
	},
	{
		title: 'Kiwi (L)',
		secondTitle: 'Spring Green (M)',
		description: '3 ensfargede',
		image: '4005_L+M',
	},
	{
		title: 'Banana (L)',
		secondTitle: 'Pale sun (M)',
		description: '3 ensfargede',
		image: '4006_L+M',
	},
	{
		title: 'Sand (L)',
		secondTitle: 'Moss Green (M)',
		description: '3 ensfargede',
		image: '4007_L+M',
	},
	{
		title: 'Dark Chocolate (L)',
		secondTitle: 'Sand (M)',
		description: '3 ensfargede',
		image: '4008_L+M',
	},
	{
		title: 'Darkest Night (L)',
		secondTitle: 'Bright Sun (M)',
		description: '3 ensfargede',
		image: '4009_L+M',
	},
	{
		title: 'Bright Orange (L)',
		secondTitle: 'Light Turquoise (M)',
		description: '3 ensfargede',
		image: '4010_L+M',
	},
	{
		title: 'Peachy Pink (L)',
		secondTitle: 'Bubble Gum Pink (M)',
		description: '3 ensfargede',
		image: '4011_L+M',
	},
	{
		title: 'Green Grass (L)',
		secondTitle: 'Dark Neon Orange (M)',
		description: '3 ensfargede',
		image: '4012_L+M',
	},
	{
		title: 'Baby Blue (L)',
		secondTitle: 'Greek Blue (M)',
		description: '3 ensfargede',
		image: '4013_L+M',
	},
	{
		title: 'Light Turquoise (L)',
		secondTitle: 'Baby Blue (M)',
		description: '3 ensfargede',
		image: '4014_L+M',
	},
	{
		title: 'Light Pink (L)',
		secondTitle: 'Spring Green (M)',
		description: '3 ensfargede',
		image: '4015_L+M',
	},
	{
		title: 'Neon Green (L)',
		secondTitle: 'Neon Yellow (M)',
		description: '3 ensfargede',
		image: '4016_L+M',
	},
	{
		title: 'Dark Neon Orange (L)',
		secondTitle: 'Green Grass (M)',
		description: '3 ensfargede',
		image: '4017_L+M',
	},
	{
		title: 'Darkest Night (L)',
		secondTitle: 'Bright Orange (M)',
		description: '3 ensfargede',
		image: '4018_L+M',
	},
	{
		title: 'Bright Sun (L)',
		secondTitle: 'Bright Orange (M)',
		description: '3 ensfargede',
		image: '4019_L+M',
	},
	{
		title: 'Camel (L)',
		secondTitle: 'Sand (M)',
		description: '3 ensfargede',
		image: '4020_L+M',
	},
	{
		title: 'Dark Chocolate (L)',
		secondTitle: 'Camel (M)',
		description: '3 ensfargede',
		image: '4021_L+M',
	},
	{
		title: 'Sand (L)',
		secondTitle: 'Camel (M)',
		description: '3 ensfargede',
		image: '4022_L+M',
	},
	{
		title: 'Ash Brown (L)',
		secondTitle: 'Moss Green (M)',
		description: '3 ensfargede',
		image: '4023_L+M',
	},
	{
		title: 'Cucumber (L)',
		secondTitle: 'Turquoise (M)',
		description: '3 ensfargede',
		image: '4024_L+M',
	},
	{
		title: 'Cucumber (L)',
		secondTitle: 'Neon Green (M)',
		description: '3 ensfargede',
		image: '4025_L+M',
	},
	{
		title: 'Navy (L)',
		secondTitle: 'Classic Blue (M)',
		description: '3 ensfargede',
		image: '4026_L+M',
	},
	{
		title: 'Fresbo (L)',
		secondTitle: 'Light Turquoise (M)',
		description: '3 ensfargede',
		image: '4027_L+M',
	},
	{
		title: 'Sandre (L)',
		secondTitle: 'Sand (M)',
		description: '3 ensfargede',
		image: '4028_L+M',
	},
	{
		title: 'Camel (M)',
		secondTitle: '',
		description: '3 ensfargede',
		image: '3006_M',
	},
	{
		title: 'Sand (M)',
		secondTitle: '',
		description: '3 ensfargede',
		image: '3007_M',
	},
	{
		title: 'Moss Green (M)',
		secondTitle: '',
		description: '3 ensfargede',
		image: '3009_M',
	},
	{
		title: 'Bright Orange (M)',
		secondTitle: '',
		description: '3 ensfargede',
		image: '3014_M',
	},
	{
		title: 'Classic Blue (M)',
		secondTitle: '',
		description: '3 ensfargede',
		image: '3017_M',
	},
	{
		title: 'Cobalt Blue (M)',
		secondTitle: '',
		description: '3 ensfargede',
		image: '3018_M',
	},
	{
		title: 'Bubble Gum Pink (M)',
		secondTitle: '',
		description: '3 ensfargede',
		image: '3021_M',
	},
	{
		title: 'Peacky Pink (M)',
		secondTitle: '',
		description: '3 ensfargede',
		image: '3022_M',
	},
	{
		title: 'Spring Green (M)',
		secondTitle: '',
		description: '3 ensfargede',
		image: '3024_M',
	},
	{
		title: 'Spring Green (L)',
		secondTitle: '',
		description: '3 ensfargede',
		image: '3024_M_2',
	},
	{
		title: 'Baby Blue (M)',
		secondTitle: '',
		description: '3 ensfargede',
		image: '3025_M',
	},
	{
		title: 'Lilac Blue (M)',
		secondTitle: '',
		description: '3 ensfargede',
		image: '3026_M',
	},
	{
		title: 'Neon Green (M)',
		secondTitle: '',
		description: '3 ensfargede',
		image: '3027_M',
	},
	{
		title: 'Ash Brown (L)',
		secondTitle: '',
		description: '3 ensfargede',
		image: '3028_L',
	},
	{
		title: 'Dark Neon Orange (M)',
		secondTitle: '',
		description: '3 ensfargede',
		image: '3030_M',
	},
	{
		title: 'Bright Sun (M)',
		secondTitle: '',
		description: '3 ensfargede',
		image: '3070_M',
	},
	{
		title: 'Green Grass (M)',
		secondTitle: '',
		description: '3 ensfargede',
		image: '3071_M',
	},
	{
		title: 'Pale Sun (M)',
		secondTitle: '',
		description: '3 ensfargede',
		image: '3078_M',
	},
	{
		title: 'Neon Yellow (M)',
		secondTitle: '',
		description: '3 ensfargede',
		image: '3083_M',
	},
	{
		title: 'Neon Yellow (L)',
		secondTitle: '',
		description: '3 ensfargede',
		image: '3083_M_2',
	},
]
